"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BAsset = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const fabricators_1 = require("../../fabricators");
const queries_1 = require("../../queries");
const operation_1 = require("../operation");
class BAsset {
    constructor(options) {
        var _a;
        this._lcd = options.lcd;
        this._addressProvider = options.addressProvider;
        this._bAssetAddressProvider = options.bAssetAddressProvider;
        this._wormholeDecimals = (_a = options.wormhole) === null || _a === void 0 ? void 0 : _a.decimals;
    }
    addresses() {
        return this._bAssetAddressProvider;
    }
    convertToWormhole(convertOptions) {
        return new operation_1.OperationImpl(fabricators_1.fabricatebAssetConvertAnchorToWormhole, Object.assign(Object.assign({}, convertOptions), { bAsset: this._bAssetAddressProvider }), this._addressProvider);
    }
    convertFromWormhole(convertOptions) {
        if (this._wormholeDecimals === undefined) {
            throw new Error('The required Wormhole information was not present.');
        }
        return new operation_1.OperationImpl(fabricators_1.fabricatebAssetConvertWormholeToAnchor, Object.assign(Object.assign({}, convertOptions), { wormholeTokenDecimals: this._wormholeDecimals, bAsset: this._bAssetAddressProvider }), this._addressProvider);
    }
    claim(claimOptions) {
        return new operation_1.OperationImpl(fabricators_1.fabricatebAssetClaimRewards, Object.assign(Object.assign({}, claimOptions), { bAsset: this._bAssetAddressProvider }), this._addressProvider);
    }
    getClaimableRewards(getClaimableRewardsOption) {
        return __awaiter(this, void 0, void 0, function* () {
            const holder = yield (0, queries_1.querybAssetRewardHolder)(Object.assign({ lcd: this._lcd, bAsset: this._bAssetAddressProvider }, getClaimableRewardsOption))(this._addressProvider);
            const rewardState = yield (0, queries_1.querybAssetRewardState)({
                lcd: this._lcd,
                bAsset: this._bAssetAddressProvider,
            })(this._addressProvider);
            return new terra_js_1.Int(new terra_js_1.Int(holder.balance).mul(new terra_js_1.Dec(rewardState.global_index).sub(new terra_js_1.Dec(holder.index))))
                .add(new terra_js_1.Int(holder.pending_rewards))
                .div(1000000)
                .toString();
        });
    }
}
exports.BAsset = BAsset;
//# sourceMappingURL=basset.js.map